export const candidateStatuses = {
    SHORTLISTED: "shortlisted",
    SELECTED: "selected",
    REJECTED: "Rejected",
    TO_REHIRE: "to_rehire",
    TEAMLEAD_HIRE: "teamlead_hire",
    TEAMLEAD_TOREHIRE: "teamlead_rehire",
    ONBOARDING: "hired",
    PENDING_SELECTION: "Pending",
    GUEST_PENDING_SELECTION: "Guest_Pending",
    REHIRE: "rehired",
    REMOVED: 'Removed',
    RENEWCONTRACT: "renew_contract",
    LEAVE: "Leave",
}
